import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
// import {getUrlParameters} from '../../common/util/urlParameters';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';

export const fecthAgenciesList = () => apiActionCreator({
  'endpoint': '/transport/agencies',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_AGENCIES_LIST,
    ActionTypes.FETCHED_AGENCIES_LIST,
    [
      ActionTypes.FETCHED_AGENCIES_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fecthProvincesList = () => apiActionCreator({
  'endpoint': '/transport/province',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PROVINCES_LIST,
    ActionTypes.FETCHED_PROVINCES_LIST,
    [
      ActionTypes.FETCHED_PROVINCES_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const updateAgency = (data, params) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/transport/agencies',
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_AGENCY_LIST,
      [
        {
          'type': ActionTypes.UPDATED_AGENCY_LIST,
        },
        (response) => {
          dispatch(fecthAgenciesList(params));
          dispatch(buildSuccessMessage(response, response.message));
        },
      ],
      [
        ActionTypes.UPDATED_AGENCY_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': data,
    'contentType': 'application/json',
  }));
};

export const exportToExcelAgencies = () => apiActionCreator({
  'endpoint': '/transport/agency/excel',
  'authenticated': true,
  'types': [
    ActionTypes.EXPORTING_TO_EXCEL_AGENCIES,
    ActionTypes.EXPORTED_TO_EXCEL_AGENCIES,
    [
      ActionTypes.EXPORTED_TO_EXCEL_AGENCIES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const cleanAgenciesUrl = () => ({
  'type': ActionTypes.CLEAN_AGENCIES_EXPORT_URL,
});
